var valueParser = {
  tryParseNumber: function tryParseNumber(value) {
    try {
      return parseInt(value);
    } catch (e) {
      return value;
    }
  },
  //supported
  //whatever js considers a valid date string
  tryParseDate: function tryParseDate(value) {
    try {
      return new Date(value);
    } catch (e) {
      return value;
    }
  },
  //supported
  // $ .......
  tryParseCurrency: function tryParseCurrency(value) {
    try {
      if (!value) // no value
        return value;
      if (value[0] < '0' || value[0] > '9') // if not a number, consider it a '$' sign
        return parseInt(value.substring(1));
      return parseInt(value); // consider it a number
    } catch (e) {
      return value;
    }
  }
};
export default valueParser;